export { cn } from '@bs/ui-components'

/**
 * `companies.logoUrl` (and every snapshot copied from it — `employment.companyLogoUrl`,
 * `exclusion_grants.excludedLogoUrl`, `jobs.companyData.logoUrl`) stores the bare GCS object name,
 * not a URL despite the field name — same "company-logos/" prefix legacy's own Go storage service
 * treats as PUBLIC (`publicFolders` in services-storage-ms/pkg/storage/client.go), same public
 * bucket the avatar feature uses. Confirmed live: a migrated company's stored value resolves here
 * with a real 200. Already-absolute values (nothing writes one today, but nothing rules it out
 * either) pass through unchanged rather than getting double-prefixed.
 */
const COMPANY_LOGO_BASE_URL = 'https://storage.googleapis.com/bs-public-bucket-20260710/company-logos/'

export function companyLogoUrl(raw: string | undefined): string | undefined {
  if (!raw) return undefined
  return raw.startsWith('http') ? raw : `${COMPANY_LOGO_BASE_URL}${raw}`
}
